import { render } from "./UserOrderHistory.vue?vue&type=template&id=2ed59a9d&scoped=true"
import script from "./UserOrderHistory.vue?vue&type=script&lang=js"
export * from "./UserOrderHistory.vue?vue&type=script&lang=js"

import "./UserOrderHistory.vue?vue&type=style&index=0&id=2ed59a9d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed59a9d"]])

export default __exports__